import { AbstractControl, ValidatorFn } from '@angular/forms';
import { PhoneNumberUtil } from 'google-libphonenumber';

const phoneUtil = PhoneNumberUtil.getInstance();

export function getUkPhoneValidator(prefixControlName?: string): ValidatorFn {
  const prefixControl = prefixControlName || 'phonePrefix';

  return (control: AbstractControl) => {
    const prefix = control.parent?.get(prefixControl)?.value;
    const value: string = control.value == null ? control.value : String(control.value);

    if (!value || !prefix) {
      return null;
    }

    try {
      const parsed = phoneUtil.parse(`${prefix}${value}`, 'GB');
      return phoneUtil.isValidNumber(parsed) ? null : { ukPhoneValidator: true };
    } catch {
      return { ukPhoneValidator: true };
    }
  };
}
